// Actions
import { changeLocalLoading, changeErr, changeSuccess } from '../App/actions'
import { changeFirstTime } from '../Auth/actions'
import { signIn } from '../SignInPage/actions'

// Axios
import { serverAPI } from '../../index'

export function signUp(reduxFormData, history) {
  return function (dispatch) {
    dispatch(changeLocalLoading(true))
    return serverAPI.post('/user/sign-up', reduxFormData)
      .then(response => {
        dispatch(changeFirstTime(true))
        dispatch(changeSuccess('Cadastro realizado. Você receberá um e-mail de confirmação em instantes.'));
        dispatch(signIn({ email: reduxFormData.email, password: reduxFormData.password, type: 'sign-up', history }))
      })
      .catch((e) => {
        dispatch(changeLocalLoading(false))
        switch (e.response.status) {
          case 400:
            dispatch(changeErr(`Não foi possível concluir o cadastro. Verifique seus dados ou entre em contato com o suporte.`))
            break;
          case 422:
            dispatch(
              changeErr("A nova senha não atende aos requisitos de segurança. Por favor, escolha uma senha mais forte.")
            );
            break;
          case 429:
            dispatch(changeErr('Muitas tentativas em um curto período de tempo. Por favor, tente novamente mais tarde.'))
            break;
          default:
            dispatch(changeErr('Desculpe, os servidores estão em manutenção no momento. Em algumas horas iremos retomar as atividades.'))
        }
      })
  }
}
